export const aboutSectionTitle = 'About Me';
export const aboutSectionSubtitle = 'My introduction';
export const aboutSectionDescriptions = [
    "I'm Adrian, a junior developer with a passion for programming and see it as a realm of unlimited creativity and innovation.",
    "I am currently looking for a job that will give me the opportunity to grow and learn new skills. I am highly motivated and ready for new challenges. In my free time I practice bodybuilding, mixed martial arts and travel the world. These interests have taught me discipline, perseverance and overcoming obstacles.",
    "If you are looking for an ambitious junior developer who is eager to learn from experienced professionals, I invite you to check out my LinkedIn for more information about my experience and skills.",
];
export const infoData = [
    {
        iconClass: 'bx bx-award about__icon',
        title: 'Experience',
        subtitle: '1.5 Years Working',
    },
    {
        iconClass: 'bx bx-briefcase-alt about__icon',
        title: 'Completed',
        subtitle: '10+ Projects',
    },
    {
        iconClass: 'bx bx-support about__icon',
        title: 'Support',
        subtitle: 'Online 24/7',
    },
];